import React from 'react';
import '../../components/Loading/loading.css';

export default function Loading() {
  return (
    <div id="preloader">
      <div id="loader"></div>
    </div>
  )
}
